import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-info">
        <p>&copy; 2024-2026 Bientech. Todos os direitos reservados.</p>
        
      </div>
      <div className="footer-security">
        <a
          href="https://letsencrypt.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="security-seal"
        >
          <img
            src="https://letsencrypt.org/images/le-logo-standard.svg"
            alt="Site Seguro"
            className="security-logo"
          />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
